module.exports = __webpack_public_path__ + "static/media/carWrong.e7f1c43e.png";